<template>
  <v-card class="elevation-12">
    <slot name="top"></slot>

    <v-card-text class="body-1">
      <v-row>
        <v-col cols="12" md="4">
          <b>Счёт-фактура</b>
          <br>{{ invoice.number }} от {{ invoice.date.format("YYYY-MM-DD") }}
        </v-col>
        <v-col cols="12" md="4">
          <b>Договор</b>
          <br>{{ invoice.contractNumber }} от {{ invoice.contractDate.format("YYYY-MM-DD") }}
        </v-col>
        <v-col cols="12" md="4">
          <b>Накладная</b>
          <br>{{ invoice.shipment.number }} от {{ invoice.shipment.date.format("YYYY-MM-DD") }}
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider/>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <h3 class="mb-4">Заказчик</h3>
          <span class="body-1 flex-grow-1">
              <b class="member-property-key d-inline-flex">Название</b> {{ invoice.customerDetails.name }}
              <br/>
              <b class="member-property-key d-inline-flex">Инн </b> {{ invoice.customerDetails.inn }}
              <br/>
              <b class="member-property-key d-inline-flex">Адрес </b> {{ invoice.customerDetails.address }}
              <br/>
              <b class="member-property-key d-inline-flex">Банковский счёт </b> {{ invoice.customerDetails.bankAccount }}
              <br/>
              <b class="member-property-key d-inline-flex">Код банка </b> {{ invoice.customerDetails.bankMfo }}
              <br/>
              <b class="member-property-key d-inline-flex">Банк </b> {{ invoice.customerDetails.bankName }}
              <br/>
              <b class="member-property-key d-inline-flex">НДС Код </b> {{ invoice.customerDetails.ndsRegistrationCode }}
          </span>
        </v-col>
        <v-col cols="12" md="6">
          <h3 class="mb-4">Поставщик</h3>
          <span class="body-1 flex-grow-1">
              <b class="member-property-key d-inline-flex">Название</b> {{ invoice.executorDetails.name }}
              <br/>
              <b class="member-property-key d-inline-flex">Инн </b> {{ invoice.executorDetails.inn }}
              <br/>
              <b class="member-property-key d-inline-flex">Адрес </b> {{ invoice.executorDetails.address }}
              <br/>
              <b class="member-property-key d-inline-flex">Банковский счёт </b> {{ invoice.executorDetails.bankAccount }}
              <br/>
              <b class="member-property-key d-inline-flex">Код банка </b> {{ invoice.executorDetails.bankMfo }}
              <br/>
              <b class="member-property-key d-inline-flex">Банк </b> {{ invoice.executorDetails.bankName }}
              <br/>
              <b class="member-property-key d-inline-flex">НДС Код </b> {{ invoice.executorDetails.ndsRegistrationCode }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider/>

    <v-card-text>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
          <tr>
            <th>№</th>
            <th>Товар</th>
            <th>Штрих-код</th>
            <th>Ед.изм</th>
            <th class="text-right">Количество</th>
            <th class="text-right">Цена за единицу</th>
            <th class="text-right">Стоимость</th>
            <th class="text-right">Ставка ндс</th>
            <th class="text-right">Сумма ндс</th>
            <th class="text-right">Стоимость с учётом НДС</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in invoice.items" :key="item.id">
            <td class="text-center">{{ index + 1 }}</td>
            <td>{{ item.product }}</td>
            <td class="text-right">{{ item.barcode }}</td>
            <td>{{ item.measurement }}</td>
            <td class="text-right"> {{ item.quantity | decimalNoTrim }}</td>
            <td class="text-right">{{ item.price | decimalNoTrim }}</td>
            <td class="text-right">{{ item.total | decimalNoTrim }}</td>
            <td class="text-right">{{ item.ndsRate | decimalNoTrim }}</td>
            <td class="text-right">
              {{ item.ndsValue | decimalNoTrim }}
            </td>
            <td class="text-right">
              {{ item.totalWithNds | decimalNoTrim }}
            </td>
          </tr>
          <tr class="blue-grey lighten-4">
            <td></td>
            <td class="text-left" colspan="5"><b>Итого</b> {{ invoice.totalInWord }}</td>
            <td class="text-right">{{ totals.total | decimalMinorCeilTwoDigit }}</td>
            <td class="text-right"></td>
            <td class="text-right">
              {{ totals.ndsValue | decimalMinorCeilTwoDigit }}
            </td>
            <td class="text-right">
              {{ totals.totalWithNds | decimalMinorCeilTwoDigit }}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-divider/>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="4" class="body-1">
          <b>Руководитель предприятия</b>: {{ invoice.executorDirector }}
          <br/>
          <b>Главный бухгалтер</b> {{ invoice.executorAccountant }}
          <br/>
          <b>Товар отпустил</b> {{ invoice.executorReleaser }}
        </v-col>
        <v-col cols="12" md="4" offset-md="4" class="body-1">
          <b>Номер доверенности</b> {{ invoice.customerProxyNumber }}
          <br/>
          <b>Доверенность от числа</b> {{ invoice.customerProxyDate }}
          <br/>
          <b>ФИО получателя</b> {{ invoice.customerProxyName }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from "underscore";

export default {
  props: {
    invoice: {
      type: Object,
      default: null
    }
  },
  name: "InvoicePreview",
  computed: {
    totals() {
      let total = 0;
      let ndsValue = 0;
      let totalWithNds = 0;

      if (this.invoice) {
        _.each(this.invoice.items, (item) => {
          total += item.total;
          ndsValue += item.ndsValue;
          totalWithNds += item.totalWithNds;
        });
      }

      return {total, ndsValue, totalWithNds};
    },
  }
}
</script>

<style scoped>
.member-property-key {
  width: 180px;
}
</style>